"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { Button } from "@jobteaser/spark/components/Button"
import { ChevronRight } from "@jobteaser/spark/components/Icons/ChevronRight"

import { Link } from "@/modules/routing/components/Link"

type CompanyLinkProps = PropsWithChildren<{
  className: string
  dataTestId: string
  url: string
}>

export const CompanyResourceLink: FunctionComponent<CompanyLinkProps> = ({ children, className, url, dataTestId }) => (
  <Button
    renderComponent={Link}
    className={className}
    data-testid={dataTestId}
    href={url}
    icon={ChevronRight}
    onBackground="dark"
    variant="primary"
  >
    {children}
  </Button>
)
